import { createFileRoute } from "@tanstack/react-router";
import { TabsExamples } from "@/utils/design-system/examples-exports";

export const Route = createFileRoute("/demo/design-system/interactive/tabs")({
  component: TabsExamples,
});
